import Progress from './Progress';

export default Progress;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/progress/index.js
// module id = 418
// module chunks = 0